module.exports = __webpack_public_path__ + "static/media/logo.40c20dc0.png";